import { Flex } from 'antd'
import banner1 from '@/assets/img/carbon/banner-1.jpg'
import FullScreenBanner from '@/components/full-screen-banner'
import Styles from './style.module.scss'

export default function Index() {
  return (
    <FullScreenBanner className={Styles.wrapper} style={{ backgroundImage: `url(${banner1})` }}>
      <div className={Styles.content}>
        <h1 className={Styles.title}>Carbon Footprint Management</h1>
        <div className={Styles.description}>
          During our development, Carus prioritizes ESG commitments, focusing on tracking and managing the carbon
          footprint of its system products. Despite industry-wide challenges, we continue to build a professional ESG
          team and maintain close collaboration with core suppliers to advance ESG initiatives and carbon footprint
          monitoring. Through Carus equipment, we aim to achieve end-to-end carbon transparency and support customers in
          jointly achieving carbon neutrality goals, enabling comprehensive carbon footprint reporting across value
          chains.
        </div>
      </div>
      <Flex justify='space-evenly' className={Styles.bottom}>
        <Flex vertical align='center'>
          <h6>Professional Team</h6>
          <div className={Styles.content}>Management Monitoring And Indicating Status Of Battery And System</div>
        </Flex>
        <Flex vertical align='center'>
          <h6>Compliant With Policies</h6>
          <div className={Styles.content}>Standard Interface For Communication AndHV Connection</div>
        </Flex>
        <Flex vertical align='center'>
          <h6>Efficient And High Reach</h6>
          <div className={Styles.content}>Liquid Cooling System + Cong Life Time LFP Cell And Multiple Protection</div>
        </Flex>
      </Flex>
    </FullScreenBanner>
  )
}
